import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  testSeriesData: [],
  totalCategory: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
  isImageOpenModal: false,
}

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setTestSeriedData(state, { payload }) {
      state.testSeriesData = payload.result
      state.totalTestSeries = payload.total
    },
    pushTestSeriesData(state, { payload }) {
      state.testSeriesData.push(payload)
      state.totalTestSeries +=1
    },
    updateTestSeriesData(state, { payload }) {
      const objIndex = state.testSeriesData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.testSeriesData[objIndex] = payload
      }
    },
    deleteTestSeriesData(state, { payload }) {
      const objIndex = state.testSeriesData.findIndex((obj) => obj._id === payload);      
      if (objIndex >= 0) {
        state.testSeriesData.splice(objIndex, 1)
      }
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    }
  }
})

export const { setTestSeriedData, updateTestSeriesData, deleteTestSeriesData, pushTestSeriesData, isOpenModal,
  ModalToggle, isOpenStatusModal, statusToggle, ImagestatusToggle, isImageOpenModal } = categorySlice.actions;

export default categorySlice.reducer;

export function getTestSeries(limit, offset, status, keyword, categoryId) {
  return async function getTestSeriesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getTestSeries(limit, offset, status, keyword, categoryId).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setTestSeriedData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addTestSeries(payload) {
  return async function addTestSeriesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addTestSeries(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushTestSeriesData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateTestSeries(id, data) {
  return async function updateTestSeriesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateTestSeries(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateTestSeriesData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdateTestSeries(payload) {
  return async function statusUpdateTestSeriesThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdateTestSeries(payload.id, payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updateTestSeriesData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function statusDeleteTestSeries(payload) {
  return async function statuseleteTestSeriesThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdateTestSeries(payload.id, payload.status).then(
        (response) => {          
          dispatch(deleteTestSeriesData(payload.id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function updateTestSeriesImage(id, file) {
  return async function updateTestSeriesImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      dispatch(isImageOpenModal())
      await service.testSeriesImage(id, file).then(
        (response) => {
          dispatch(updateTestSeriesData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}